// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"a96dfd86","732":"e67e2378","977":"754e5137"}[chunkId] + ".chunk.js";
};